import React from 'react'

import { IconProps } from '../../../common/types'

const SortUpDown: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85886 9.00292C4.98363 8.87819 5.15283 8.80812 5.32925 8.80812C5.50567 8.80812 5.67487 8.87819 5.79963 9.00292L7.99056 11.1938L10.1815 9.00292C10.2429 8.93938 10.3163 8.88869 10.3974 8.85382C10.4786 8.81895 10.5659 8.8006 10.6543 8.79983C10.7426 8.79906 10.8302 8.8159 10.912 8.84935C10.9937 8.8828 11.068 8.93221 11.1305 8.99467C11.193 9.05714 11.2424 9.13143 11.2758 9.2132C11.3093 9.29496 11.3261 9.38257 11.3253 9.47091C11.3246 9.55926 11.3062 9.64656 11.2714 9.72773C11.2365 9.8089 11.1858 9.88232 11.1223 9.94369L8.46095 12.605C8.33618 12.7297 8.16698 12.7998 7.99056 12.7998C7.81414 12.7998 7.64494 12.7297 7.52017 12.605L4.85886 9.94369C4.73413 9.81893 4.66406 9.64973 4.66406 9.47331C4.66406 9.29689 4.73413 9.12769 4.85886 9.00292Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1306 6.99659C11.0058 7.12132 10.8366 7.19139 10.6602 7.19139C10.4838 7.19139 10.3146 7.12132 10.1898 6.99659L7.99888 4.80567L5.80795 6.99659C5.74658 7.06014 5.67316 7.11082 5.59199 7.14569C5.51082 7.18056 5.42351 7.19891 5.33517 7.19968C5.24683 7.20045 5.15922 7.18362 5.07745 7.15016C4.99569 7.11671 4.9214 7.06731 4.85893 7.00484C4.79646 6.94237 4.74706 6.86808 4.71361 6.78632C4.68015 6.70455 4.66332 6.61694 4.66409 6.5286C4.66486 6.44026 4.68321 6.35295 4.71808 6.27178C4.75295 6.19061 4.80363 6.11719 4.86718 6.05582L7.52849 3.39451C7.65326 3.26978 7.82246 3.19971 7.99888 3.19971C8.1753 3.19971 8.3445 3.26978 8.46926 3.39451L11.1306 6.05582C11.2553 6.18058 11.3254 6.34978 11.3254 6.5262C11.3254 6.70262 11.2553 6.87182 11.1306 6.99659Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SortUpDown
